import React from "react";
import { Menu, UtensilsCrossed } from "lucide-react";

// Logo alternativo en caso de no tener uno configurado
const LogoValleDelSol = () => (
  <div className="relative w-full h-full flex items-center justify-center">
    <div
      className="absolute inset-0 bg-sky-200 rounded-full border-2 border-gray-800"
      style={{
        clipPath:
          "polygon(50% 0%, 83% 12%, 100% 43%, 94% 78%, 68% 100%, 32% 100%, 6% 78%, 0% 43%, 17% 12%)",
      }}
    ></div>
    <div className="absolute top-2 text-gray-800">
      <UtensilsCrossed className="w-6 h-6 fill-gray-800" />
    </div>
  </div>
);

const Header = ({ onLogout, userRole, onOpenMenu, globalConfig }) => {
  // Extraemos variables configuradas para hacer el navbar 100% White-Label
  const storeName = globalConfig?.general?.storeName || "Valle del Sol";
  const logoUrl = globalConfig?.general?.logoUrl; 
  const navbarColor = globalConfig?.theme?.navbar || "#ffffff";
  const primaryColor = globalConfig?.theme?.primary || "#4CAF50";

  // Lógica para determinar color de texto para asegurar buen contraste en el navbar. 
  // (Si el navbar es blanco, el texto es oscuro, sino blanco)
  const isLightNavbar = navbarColor === "#ffffff" || navbarColor.toLowerCase() === "#fff";

  return (
    <div 
      className="p-1 pb-4 rounded-b-2xl shadow-md mb-3 flex items-center gap-3 relative h-14 transition-colors"
      style={{ 
        backgroundColor: navbarColor,
        color: isLightNavbar ? "#333333" : "#ffffff" 
      }}
    >
      <button
        onClick={onOpenMenu}
        className="z-10 ml-1 p-2 rounded-lg hover:opacity-80 active:scale-95 transition-all shadow-sm"
        style={{ backgroundColor: primaryColor }} // Botón dinámico con color principal
      >
        <Menu className="w-5 h-5 text-white" />
      </button>

      <div className="z-10 mt-1 flex-1 text-center">
        <h1 className="font-extrabold text-lg tracking-wide uppercase font-serif leading-tight">
          {storeName}
        </h1>
        <p className={`text-[10px] font-medium tracking-wider ${isLightNavbar ? 'text-gray-500' : 'text-white/80'}`}>
          {userRole === "kitchen" ? "Modo Cocina" : "Gestión Integral"}
        </p>
      </div>

      <div 
        className="p-0 rounded-full shadow-md z-10 w-11 h-11 flex-shrink-0 overflow-hidden flex items-center justify-center border-2"
        style={{ borderColor: primaryColor, backgroundColor: '#fff' }}
      >
        {logoUrl ? (
          <img
            src={logoUrl}
            alt="Logo"
            className="w-full h-full object-cover rounded-full"
          />
        ) : (
          <LogoValleDelSol />
        )}
      </div>
    </div>
  );
};

export default Header;